import { Component, Output, EventEmitter, Input } from '@angular/core';

export interface Filter {
    name: string;
}

@Component({
    selector: 'filter',
    templateUrl: 'filter.component.html',
    styleUrls: ['filter.component.scss']
})
export class FilterComponent {

    @Input()
    filter: Filter = {
        name: ''
    };

    isOpened = false;

    @Output()
    applied = new EventEmitter<Filter>();

    apply() {
        this.applied.emit(this.filter);
    }

    toggle() {
        this.filter.name = '';
        this.apply();
        this.isOpened = !this.isOpened;
    }
}
